import { defaultScalableStyle } from '../presets';
import type { ScalableProductCARD_STYLE_TYPE } from '../types';

const LOCAL_STORAGE_NAME = 'scalableProductStyle';

export const setScalableStyleToLocalStorage = (scalableStyle: ScalableProductCARD_STYLE_TYPE) => {
    localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(scalableStyle));
};

export const getScalableStyleFromLocalStorage = () => {
    const localScalableStyle = localStorage.getItem(LOCAL_STORAGE_NAME);

    if (!localScalableStyle) {
        return defaultScalableStyle;
    }

    const scalableStyle: ScalableProductCARD_STYLE_TYPE = JSON.parse(localScalableStyle);

    return scalableStyle;
};
